export { Sender } from "./Sender";
//# sourceMappingURL=applicationinsights-channel-js.js.map